<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container d-flex flex-column bg-gray">
        <header class="mdc-top-app-bar position-static">
          <div class="mdc-top-app-bar__row">
            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            >
              <!-- <a class="material-icons mdc-top-app-bar__navigation-icon" @click="routerGoPrev()">close</a> -->
              <a
                class="material-icons mdc-top-app-bar__navigation-icon"
                @click="goBackToSurvey"
                >close</a
              >
            </section>

            <section class="mdc-top-app-bar__section title">
              <div class="mdc-top-app-bar__title">
                {{ $t("724") }}
                <!-- 설문 결과 -->
              </div>
            </section>

            <section
              class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            >
              <a
                class="material-icons mdc-top-app-bar__action-item"
                aria-label="search"
                alt="search"
              ></a>
            </section>
          </div>
        </header>

        <section class="flex-grow-1 scroll-y">
          <div class="t-center mgr-16 mgl-16">
            <div class="mgt-50 mgr-26 mgl-26">
              <img src="/images/survey_image.png" class="top-img" />
            </div>
            <div class="t-headline3-result mgt-28">
              {{ $t("725") }}
              <!-- 설문조사 완료 -->
            </div>
            <div
              class="mgt-8 t-body3 t-center close-message"
              v-html="surveyData.closeMessage"
            >
              <!-- {{}} -->
              <!-- 설문에 참여해주셔서 감사합니다.<br>
                            획득한 리워드를 확인해보세요! -->
            </div>
          </div>
          <hr class="divider" />
          <div class="pda-default">
            <div v-if="surveyData.point">
              <div class="mgt-6 t-subtitle1 title">
                {{ $t("726") }}
                <!-- 리워드 -->
              </div>
              <div class="mdc-card mdc-elevation--z3 mgt-9">
                <div class="pda-default">
                  <div
                    class="t-subtitle2 d-flex flex-row justify-content-between align-items-center"
                  >
                    <span>{{ $t("727") }}</span>
                    <!-- 획득한 포인트 -->
                    <span class="t-subtitle3">
                      {{
                        $t("729", {
                          str: $n(
                            surveyData.point.allResponse +
                              surveyData.point.complete
                          ),
                        })
                      }}
                      <!-- {{$t('729')}} -->
                    </span>

                    <!-- Total 100 Points -->
                  </div>
                  <div class="t-body1 mgt-16">
                    <div
                      class="t-subtitle3 d-flex flex-row justify-content-between align-items-center pdt-16 pdb-16"
                    >
                      <img src="@/assets/icon_point.svg" alt="" class="icon" />
                      <div class="mgr-16 mgl-16 t-color-gray2">
                        {{ $t("730") }}
                        <!-- 설문 완료 포인트 -->
                      </div>
                      <div class="flex-grow-1 d-flex flex-row-reverse">
                        {{ $t("701", { str: $n(surveyData.point.complete) }) }}
                        <!-- 100 {{$t('701')}} -->
                      </div>
                    </div>
                    <div
                      class="t-subtitle3 d-flex flex-row justify-content-between align-items-center pdt-16 pdb-16"
                    >
                      <img src="@/assets/icon_point.svg" alt="" class="icon" />
                      <div class="mgr-16 mgl-16 t-color-gray2">
                        {{ $t("731") }}
                        <!-- 전 문항 응답 포인트 -->
                      </div>
                      <div class="flex-grow-1 d-flex flex-row-reverse">
                        {{
                          $t("701", { str: $n(surveyData.point.allResponse) })
                        }}
                        <!-- 100{{$t('701')}} -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="mdc-card mdc-elevation--z3 mgt-16"
                v-if="surveyData.badges.length"
              >
                <div class="pda-default">
                  <div class="t-subtitle2">
                    {{ $t("732") }}
                    <!-- 획득한 배지 -->
                  </div>
                  <div class="mgt-6">
                    <div
                      class="t-body1"
                      v-for="(badge, index) in surveyData.badges"
                      :key="index"
                    >
                      <div
                        class="d-flex flex-row justify-content-between align-items-center pdt-16 pdb-16"
                      >
                        <div v-if="badge.image">
                          <img :src="badge.image" alt="" class="badge" />
                        </div>
                        <div class="t-body1 flex-grow-1 mgr-16 mgl-16">
                          {{ badge.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pda-default">
            <div>
              <button
                class="mdc-button mdc-button--raised btn-red w-full"
                @click="moveSurveyFeedback()"
              >
                {{ $t("733") }}
                <!-- 피드백  보기 -->
              </button>
            </div>
            <div>
              <!-- <button class="mdc-button btn-white w-full mgt-16" @click="moveSurveyView()">
                                {{$t('734')}}
                              
                            </button>  -->
              <button
                class="mdc-button btn-white w-full mgt-16 mgb-34"
                @click="goBackToSurvey"
              >
                {{ $t("734") }}
              </button>
            </div>
          </div>
        </section>

        <!-- <section>
          <div class="pda-default">
            <div>
              <button
                class="mdc-button mdc-button--raised btn-red w-full"
                @click="moveSurveyFeedback()"
              >
                {{ $t("733") }}
                <!-- 피드백  보기 -->
        <!--  </button>
            </div>
            <div>
             <button class="mdc-button btn-white w-full mgt-16" @click="moveSurveyView()">
                                {{$t('734')}}
                              
                            </button>  -->
        <!-- <button
                class="mdc-button btn-white w-full mgt-16 mgb-34"
                @click="goBackToSurvey"
              >
                {{ $t("734") }}
              </button>
            </div>
          </div>
        </section> -->
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 설문 결과 컴포넌트(survey result component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";

export default {
  name: "surveyResult",

  mixins: [surveyMixin],

  data() {
    return {
      surveyData: {},
    };
  },

  created() {
    this.fatchData();
    this.$parent.fatchData();
  },

  methods: {
    // 설문 결과 데이터(get survey respondent result data)
    fatchData() {
      let params = {
        respondentId: this.$route.params.respondentId,
      };

      surveyApi.surveyRespondentResult(params).then((response) => {
        console.log("response.data.data", response.data.data);
        this.surveyData = response.data.data;
      });
    },
    goBackToSurvey() {
      if (this.$route.query.distributionType == "SATISFACTION") {
        this.$router.push(
          "/learn/" +
            this.$route.query.learnId +
            "?status=" +
            this.$route.query.status +
            "&tab=viewSurvey"
        );
      } else {
        this.$router.push({
          name: "IndependentSurveyTotalView",
          params: { distId: this.$route.params.distId },
          query: this.$route.query,
        });
      }
    },
  },
};
</script>
<style scoped>
.top-img {
  width: 190.3px;
  height: 124px;
  display: inline;
}
.t-headline3-result {
  font-size: 1.125rem;
  font-weight: 600;
}
/* .close-message >>> p > strong > em { */
/* font-size: 1.125rem !important;
  color: #818181 !important;
  font-style: normal !important;
  font-weight: normal !important; */
/* } */
/* .close-message >>> p > span { */
/* font-size: 1.125rem !important;
  color: #818181 !important;
  font-style: normal !important;
  font-weight: normal !important;
  display: block !important;
  margin-top: 0px !important;
  margin-bottom: 16px !important;
  padding-top: 0 !important;
  border-top: 0 !important; */
/* color: #383838; */
/* font-size: 24px; */
/* } */
</style>